<template>
  <div class="order-search-container">
    <div :class="{ 'order-search': true, 'order-search-active': inputStatus }">
      <div
        class="order-search-input"
        @mouseenter="
          () => {
            if (searchKey) {
              deleteIcon = true;
            }
          }
        "
        @mouseleave="deleteIcon = false"
      >
        <input
          v-model="searchKey"
          type="text"
          ref="orderSearchInput"
          class="order-search-input__inner"
          placeholder="订单号/参考号/提单号"
          maxlength="20"
          @focus="focusInput"
          @blur="blurInput"
          @keydown.enter="submitSearch"
        />
        <!-- <div class="delete-icon" v-show="deleteIcon">
           <i  class="el-icon-error by-icon-delete" @click="clearInput"></i>
        </div> -->
        <i
          class="el-icon-error by-icon-delete delete-icon"
          @click="clearInput"
          v-show="deleteIcon"
        ></i>
      </div>
      <button
        type="button"
        class="order-search-button by-button--primary"
        @click="submitSearch"
      >
        <span>搜索</span>
      </button>
    </div>
  </div>
</template>

<script>
import { fetch, post } from "@/ask/axios";
import bus from "@/ask/eventBus";
export default {
  props: {
    checkType: {
      // 查价类型
      type: String,
      default: "fba",
    },
    ordKeyWord: {
      // 搜索关键词
      ype: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      inputStatus: false, // 输入框状态

      searchKey: "", // 搜索关键词
      channelList: [], // 渠道列表
      deleteIcon: false, // 删除按钮
    };
  },
  computed: {},
  watch: {
    channelName: {
      handler(val) {
        this.searchKey = val;
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {
    // 获取渠道列表
    // if (process.client) {
    bus.$on("saveChannelSuccess", () => {
      this.channelList = this.$store.state.user.channelNameList;
      // this.getChannelHistory();
    });

    // }
  },
  methods: {
    // 清除input值
    clearInput() {
      this.searchKey = "";
      this.submitSearch();
    },

    // 搜索渠道
    submitSearch() {
      this.searchKey = this.searchKey.trim();
      this.$emit("submitSearch", this.searchKey);
    },

    focusInput() {
      this.inputStatus = true;
      // 选中文本
      this.$refs.orderSearchInput.select();
    },
    blurInput() {
      this.inputStatus = false;
    },
  },
};
</script>

<style scoped lang="scss">
.order-search-container {
  position: relative;
  .order-search {
    display: flex;
    align-items: center;
    width: 200px;
    height: 32px;
    padding: 0 3px 0 12px;
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #dddddd;
    position: relative;
    box-sizing: border-box;
    transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

    &:hover {
      border-color: #aaaaaa;
    }
    .order-search-input {
      // flex: 1;
      // display: flex;
      // align-items: center;
      line-height: 18px;
      position: relative;
      .order-search-input__inner {
        width: 167px;
        height: 18px;
        padding: 6px 0;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 18px;
        // line-height: 30px;
        outline: none;
        border: none;
        // box-sizing: border-box;
        &::-webkit-input-placeholder {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #aaaaaa;
          line-height: 20px;
          // line-height: 30px;
        }
      }

      .delete-icon {
        position: absolute;
        top: 7px;
        right: 27px;
        // width: 24px;
        background: #fff;
        // height: 30px;
        // top: 7px;
        // right: 2px;
        z-index: 1;

        i {
          padding: 7px 4px;
          font-size: 16px;
          cursor: pointer;
        }
        // background: #fff;
      }
    }

    .order-search-button {
      outline: none;
      border: none;
      display: block;
      width: 44px;
      height: 24px;
      background: #0046b9;
      border-radius: 12px;
      box-sizing: border-box;
      position: absolute;
      right: 3px;

      span {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 18px;
      }
    }
  }

  .order-search-active {
    border-color: #0046b9;
    &:hover {
      border-color: #0046b9;
    }
  }

  .order-search-panel {
    position: absolute;
    left: -100px;
    z-index: 10;
    width: 440px;
    // height: 184px;
    padding: 16px;
    background: #ffffff;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    box-sizing: border-box;

    .panel-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .panel-title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
      }

      .panel-clear {
        cursor: pointer;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0046b9;
        line-height: 22px;
      }
    }

    .panel-list {
      margin-left: -8px;
      display: flex;
      flex-flow: wrap;

      .panel-list-item {
        margin: 8px 0 0 8px;
        min-width: 10px;
        max-width: 408px;
        width: max-content;
        padding: 6px 8px;
        cursor: pointer;
        background: rgba(0, 0, 0, 0.04);
        transition: background 0.1s ease-in-out;
        border-radius: 4px;
        box-sizing: border-box;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #777777;
          line-height: 20px;
        }

        &:hover {
          background: rgba(0, 0, 0, 0.06);
        }
      }
    }

    .panel-list-empty {
      margin-top: 8px;
      span {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #aaa;
        line-height: 20px;
      }
    }

    .order-search-panel__hot {
      margin: 16px 0 8px 0;
    }
  }

  .order-search-channel {
    position: absolute;
    left: 0;
    z-index: 10;
    min-width: 240px;
    max-width: 558px;
    // width: 240px;
    width: max-content;
    background: #ffffff;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    .channel-list {
      padding: 8px 6px 8px 8px;
      margin-right: 2px;
      box-sizing: border-box;
      height: auto;
      max-height: 300px;
      overflow-x: hidden;
      overflow-y: auto;

      .channel-list-item {
        // width: 160px;
        width: 100%;
        height: 24px;
        padding: 0 8px;
        box-sizing: border-box;
        background: #fff;
        border-radius: 4px;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:hover {
          cursor: pointer;
          background: #f7f8fa;
        }

        span {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
        }

        .active-color {
          color: #0046b9;
        }
      }
    }

    .channel-list-empty {
      margin: 16px 16px;
      span {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #aaa;
        line-height: 20px;
      }
    }
  }
}

.order-search-container /deep/ .channel-list::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.order-search-container /deep/ .channel-list::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 4px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  -webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  background: #e0e0e0;
}

.order-search-container /deep/ .channel-list::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  //  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  // -webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  border-radius: 4px;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/backstageManagement/home/public/OrderSearch.vue